module.exports = __webpack_public_path__ + "img/6.f5d665e2.png";